import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Head from 'next/head';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@@client/app/Layout';
var imageStyle = {
  styles: /*#__PURE__*/_jsx(_JSXStyle, {
    id: "1646168271",
    children: [".jsx-1646168271{border-radius:3px;}"]
  }),
  className: "jsx-1646168271"
};
export default function FourOhFour() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "robots",
        content: "noindex"
      })
    }), /*#__PURE__*/_jsxs(Layout, {
      title: "Page Not Found \u2014 404",
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-3053198605" + " " + 'container',
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-3053198605" + " " + 'grid',
          children: /*#__PURE__*/_jsxs("div", {
            className: "jsx-3053198605" + " " + 'row',
            children: [/*#__PURE__*/_jsxs("div", {
              className: "jsx-3053198605" + " " + 'col-lg50',
              children: [/*#__PURE__*/_jsx("h1", {
                className: "jsx-3053198605",
                children: "OOPS!"
              }), /*#__PURE__*/_jsx("p", {
                className: "jsx-3053198605" + " " + 'message',
                children: "We can\u2019t seem to find the page or item you\u2019re looking for, but we did find this awesomeness in one of our cars recently."
              }), /*#__PURE__*/_jsx("p", {
                className: "jsx-3053198605",
                children: /*#__PURE__*/_jsx(Link, {
                  href: "/",
                  children: /*#__PURE__*/_jsx("a", {
                    className: "jsx-3053198605" + " " + 'btn btn--blue--dark',
                    children: "HOME"
                  })
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-3053198605" + " " + 'col-lg50 image-col',
              children: /*#__PURE__*/_jsx(Image, {
                className: imageStyle.className,
                width: "691",
                height: "489",
                layout: "responsive",
                src: "/images/content/wwf-found-in-car.png",
                alt: "hulk hogan and macho man photo found in a used car."
              })
            })]
          })
        })
      }), imageStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
        id: "3053198605",
        children: [".container.jsx-3053198605{background:#DBE9F9;padding:30px 0;}", "@media(min-width:992px){.container.jsx-3053198605{padding:60px 0;}}", "h1.jsx-3053198605{font-family:\"Cubano\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:3.125rem;}", ".message.jsx-3053198605{font-family:\"Cubano\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:1.625rem;text-transform:uppercase;color:#21409A;}", ".image-col.jsx-3053198605{margin-top:30px;}", "@media(min-width:992px){.image-col.jsx-3053198605{margin-top:0;}}"]
      })]
    })]
  });
}